export const excisting_types = [
  "ΑΤΟΜΙΚΗ ΕΠΙΧΕΙΡΗΣΗ",
  "ΜΕΤΟΧΟΣ ΣΕ Α.Ε.",
  "ΟΜΟΡΡΥΘΜΟΣ ΕΤΑΙΡΟΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΕΤΕΡΟΡΡΥΘΜΟΣ ΕΤΑΙΡΟΣ",
  "ΕΤΑΙΡΟΣ ΣΕ Ε.Π.Ε.",
  "ΕΤΑΙΡΟΣ ΕΠΕ",
]

export const new_types = [
  "ΑΤΟΜΙΚΗ ΕΠΙΧΕΙΡΗΣΗ",
  "ΜΕΤΟΧΟΣ ΣΕ Α.Ε.",
  "ΟΜΟΡΡΥΘΜΟΣ ΕΤΑΙΡΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΕΤΕΡΟΡΡΥΘΜΟΣ ΕΤΑΙΡΟΣ",
  "ΕΤΑΙΡΟΣ ΣΕ Ε.Π.Ε.",
  "ΕΤΑΙΡΟΣ ΣΕ Ε.Π.Ε.",
]